/**
 * Hybrid KeyboardKey Component
 * Automatically chooses between Tailwind and styled-components based on props
 */

import * as React from "react";
import Text from "@sproutsocial/seeds-react-text";
import Container from "./styles"; // Styled-components version
import { KeyboardKeyTailwind } from "./KeyboardKeyTailwind"; // Tailwind version
import { hasStyledProps } from "@sproutsocial/seeds-react-system-props";
import type { TypeKeyboardKeyProps } from "./KeyboardKeyTypes";

export const KeyboardKeyHybrid = ({
  children,
  ...rest
}: TypeKeyboardKeyProps) => {
  if (hasStyledProps(rest)) {
    return (
      <Container {...rest}>
        <kbd data-qa-keyboardkey={children}>
          <Text>{children}</Text>
        </kbd>
      </Container>
    );
  }

  // Use Tailwind version (preferred - better performance)
  return <KeyboardKeyTailwind {...rest}>{children}</KeyboardKeyTailwind>;
};

KeyboardKeyHybrid.displayName = "KeyboardKey";
